export const activity = {
  order: {
    created: {
      title: 'Estimate created',
      icon: 'fal fa-file-alt',
    },
    added: {},
    updated: {
      title: 'Estimate updated',
    },
    removed: {
      title: 'Estimate removed',
      icon: 'fal fa-trash',
    },
    approved: {
      title: 'Estimate Approved',
      icon: 'fal fa-check',
    },
    sent: {
      title: 'Estimate sent',
      icon: 'fal fa-paper-plane',
    },
  },
  inspection: {
    added: {
      title: 'Inspection/inspection added',
      icon: 'fal fa-tools',
    },
    created: {
      title: 'Inspection/inspection added',
      icon: 'fal fa-tools',
    },
    updated: {
      title: 'Inspection/inspection updated',
      icon: 'fas fa-tasks',
    },
    removed: {
      title: 'Inspection removed',
      icon: 'fal fa-trash',
    },
    sent: {
      title: 'Inspection sent',
      icon: 'fal fa-paper-plane',
    },
    more: {
      title: 'More Inspection/inspection added',
      icon: 'fal fa-plus',
    },
    start: {
      title: 'Inspection/inspection updated',
      icon: 'fas fa-tasks',
    },
    inprogress: {
      title: 'Inspection {name} updated to in progress',
      icon: 'fas fa-tasks',
    },
    pause: {
      title: 'Inspection {name} updated to pause',
      icon: 'fas fa-tasks',
    },
    completed: {
      title: 'Inspection {name} updated to completed',
      icon: 'fas fa-tasks',
    },
  },
  service: {
    added: {
      title: 'Service/services added',
      icon: 'fal fa-user-hard-hat',
    },
    updated: {
      title: 'Service/services updated',
      icon: 'fas fa-wrench',
    },
    removed: {
      title: 'Service/services removed',
      icon: 'fal fa-trash',
    },
    sent: {
      title: 'Service sent',
      icon: 'fal fa-paper-plane',
    },
    more: {
      title: 'More Service/services added',
      icon: 'fal fa-plus',
    },
    start: {
      title: 'Service/services updated',
      icon: 'fas fa-wrench',
    },
    inprogress: {
      title: 'Service {name} updated to in progress',
      icon: 'fas fa-wrench',
    },
    pause: {
      title: 'Service {name} updated to pause',
      icon: 'fas fa-wrench',
    },
    completed: {
      title: 'Service {name} updated to completed',
      icon: 'fas fa-wrench',
    },
  },
  status: {
    created: {
      title: '',
    },
    added: {
      title: '',
    },
    updated: {
      title: 'Status updated',
      icon: 'fal fa-tag',
    },
    removed: {
      title: '',
    },
    sent: {
      title: '',
    },
    other: {
      title: '',
    },
  },
  invoice: {
    created: {
      title: 'Invoice created',
    },
    added: {
      title: 'Invoice added',
    },
    updated: {
      title: 'Invoice Updated',
    },
    removed: {
      title: 'Invoice removed',
    },
    sent: {
      title: 'Invoice sent',
      icon: 'fal fa-paper-plane',
    },
  },
  payment: {
    created: {
      title: 'Payment received',
      icon: 'fas fa-dollar-sign'
    }
  },
  other: {},
  authorization: {
    approved: {
      title: 'Approved',
      icon: 'fal fa-check',
    },
    notUnapproved: {
      title: 'Not Approved',
      icon: 'fal fa-check',
    },
  },
};

export const estimateActivityTypes = {
  estimate: 'order',
  inspection: 'inspection',
  service: 'service',
  status: 'status',
  invoice: 'invoice',
  payment: 'payment',
  authorization: 'authorization',
};

export const estimateActivityActions = {
  created: 'created',
  added: 'added',
  updated: 'updated',
  removed: 'removed',
  sent: 'sent',
  received: 'received',
  approved: 'approved',
  notApproved: 'notApproved',
  cancelled: 'cancelled',
  other: 'other',
};
